<template>
  <NuxtLink
    class="relative rounded-2xl overflow-hidden h-[324px] overflow-y-hidden shadow-lg flex flex-col md:flex-row gap-4 cursor-pointer"
    :class="activeItem ? 'bg-blue' : ''"
    :to="`/formaciones/${item.slug}`"
  >
    <div
      class="relative delay-75 box-border p-4 h-full"
      :class="!activeItem ? 'md:w-full ' : 'w-full md:w-1/2'"
    >
      <img
        :src="item.imageUrl"
        alt="Course image"
        class="w-full h-full object-cover rounded-2xl"
      />
      <!-- :class="{ 'border-[20px] h-80 rounded-3xl border-blue': activeItem }" -->

      <div
        class="absolute top-7 left-7 text-sm font-poppins text-white font-medium px-3 py-1 module"
      >
        {{ item.modules.length }} Módulos
      </div>
      <div
        class="absolute bottom-4 left-4 w-full bg-gradient-to-t from-black/70 to-transparent p-4"
      >
        <h3
          class="text-white font-semibold text-base leading-tight font-poppins"
        >
          {{ item.title }}
        </h3>
      </div>
    </div>

    <!-- Only render if description exists -->
    <Transition name="fade-delay">
      <div
        v-if="showDescription"
        class="w-full md:w-1/2 text-left px-4 flex flex-col justify-center my-4 text-white"
      >
        <p class="text-sm text-blue-700 font-semibold mb-1 font-poppins">
          {{ item.subtitle }}
        </p>
        <p class="text-sm text-gray-700 font-poppins mb-4">
          {{ item.description.slice(0, 140) + "..." }}
        </p>
        <!-- -------------- -->
        <p class="text-sm text-blue-700 font-semibold mb-1 font-poppins">
          ¿A quién va dirigido?
        </p>
        <p class="text-sm text-gray-700 font-poppins mb-4">
          {{ item.targetAudience }}
        </p>
        <!-- -------------- -->
        <p class="text-sm text-blue-700 font-semibold mb-2 font-poppins">
          Formato y duración
        </p>
        <p class="text-sm text-gray-700 font-poppins mb-2">
          ·Duración: {{ item.duration }} h<br />
          ·Modalidad: {{ item.modality }}
        </p>
      </div>
    </Transition>
  </NuxtLink>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import type { Course } from "~/types/Cours";

const props = defineProps<{
  item: Course;
  activeItem: boolean;
}>();

const descriptionTitle = "Programa Ejecutivo para la Alta Dirección";

// control delayed showing
const showDescription = ref(false);
let timer: any = null;

watch(
  () => props.activeItem,
  (val) => {
    clearTimeout(timer);
    if (val && props.item.description) {
      // wait 1s before showing
      timer = setTimeout(() => {
        showDescription.value = true;
      }, 300);
    } else {
      showDescription.value = false;
    }
  }
);
</script>

<style scoped>
.module {
  border-radius: 32px;
  background: var(--Glass-Grey, rgba(194, 194, 194, 0.5));
  box-shadow: 0 5px 5px 0 rgba(49, 49, 49, 0.1);
  backdrop-filter: blur(8px);
}
.fade-delay-enter-active {
  transition: opacity 0.5s ease 0.2s;
}
.fade-delay-leave-active {
  transition: opacity 0.3s ease;
}
.fade-delay-enter-from,
.fade-delay-leave-to {
  opacity: 0;
}
</style>
